import { atom, useRecoilState } from 'recoil'
import moment from 'moment'
import { TimeRange } from 'models'

const statsTimeRange = atom({
  key: 'statsTimeRange',
  default: TimeRange.LastTwelveMonths
})

const statsYearRange = atom({
  key: 'statsYearRange',
  default: parseInt(moment().format('y'))
})

export const useGetStatsTimeRange = () => {
  return useRecoilState(statsTimeRange)
}

export const useYearRange = () => {
  return useRecoilState(statsYearRange)
}
